module.exports = __webpack_public_path__ + "static/img/cont2901.304f4b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2901.jpg
// module id = IC+8
// module chunks = 0